import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DeviationSubjectType } from '../../../../../shared/deviations/types';
import { CustomerDashboardDeviationType, Deviation } from '../types';

@Component({
  selector: 'dashboard-customers-deviations',
  templateUrl: './deviations.component.html',
  styleUrls: ['./deviations.component.scss']
})
export class DashboardCustomersDeviationsComponent {
  @Input() deviations: Deviation[] = [];

  readonly DeviationSubjectType = DeviationSubjectType;

  constructor(private Router: Router) { }

  get visibleDeviations(): Deviation[] {
    return this.deviations.filter(deviation => deviation.count > 0);
  }

  getDescription(type: number): string {
    switch(type) {
      case CustomerDashboardDeviationType.blocked:
        return 'Geblokkeerde klanten';
      case CustomerDashboardDeviationType.outstandingInvoices:
        return 'Klanten met openstaande facturen';
      case CustomerDashboardDeviationType.overdueInvoices:
        return 'Klanten met achterstallige facturen';
      default:
        return '';
    }
  }

  trackByType(_index: number, deviation: Deviation): number {
    return deviation.type;
  }

  showDeviations(): void {
    this.Router.navigateByUrl('customers');
  }
}
